import type { WorkflowState } from './slices/workflowSlice';

const KEY = 'flahafast.workflow.v3';

export function clearPersistedWorkflow(): void {
  try {
    sessionStorage.removeItem(KEY);
    sessionStorage.removeItem('flahafast.workflow.v2');
    sessionStorage.removeItem('flahafast.workflow.v1');
  } catch { /* Storage can be unavailable in private browsing. */ }
}

export function loadWorkflowState(userId: string): WorkflowState | undefined {
  try {
    // Old drafts have no owner and cannot safely be restored.
    sessionStorage.removeItem('flahafast.workflow.v2');
    sessionStorage.removeItem('flahafast.workflow.v1');
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return undefined;
    const record = JSON.parse(raw);
    const state = record?.workflow;
    if (record?.userId !== userId || !state || typeof state !== 'object' || !('activeContext' in state)) {
      clearPersistedWorkflow();
      return undefined;
    }
    return { ...state, loading: false, error: null };
  } catch {
    clearPersistedWorkflow();
    return undefined;
  }
}

export function saveWorkflowState(userId: string, workflow: WorkflowState): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ userId, workflow: {
      ...workflow, loading: false, error: null,
    } }));
  } catch { /* Keep the in-memory draft when storage is full or unavailable. */ }
}
